import { Observer } from 'mobx-react';
import * as React from 'react';

import { FormModal } from 'src/modules/transferRegistration/components/FormModal';
import { openModalStore } from 'src/modules/transferRegistration/stores';

export const Base = () => {
  return <Observer>{() => (openModalStore.value ? <FormModal open={openModalStore.value} /> : null)}</Observer>;
};
